import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/gossip';

const plays = [
  {
    id: 'play-lottery',
    icon: 'ri-gift-2-line',
    title: '福利吃瓜转发抽奖',
    desc: '转发话题并完成评论区打卡，即可获得抽奖资格。规则透明，单账号单次有效，不用反复操作。',
    accent: 'bg-primary-500 text-background-50',
    tag: '每日 20:00 开奖',
  },
  {
    id: 'play-checkin',
    icon: 'ri-calendar-check-line',
    title: '评论区打卡',
    desc: '在话题下留下你的看法就算当日打卡成功，连续天数实时累计，达到节点自动解锁对应福利。',
    accent: 'bg-secondary-500 text-background-50',
    tag: '24 小时开放',
  },
  {
    id: 'play-vote',
    icon: 'ri-bar-chart-2-line',
    title: '粉丝投票',
    desc: '一人一票选出每周最想二刷的名场面，结果即时更新，让排名更接近真实的人数分布。',
    accent: 'bg-accent-500 text-foreground-950',
    tag: '每人限投一次',
  },
];

export default function PlaySection() {
  return (
    <section id="play" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="互动玩法"
        title="三种玩法，让吃瓜不只是围观"
        desc="选择你想参与的方式，每种玩法都有清晰的规则和实时的进度反馈。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
        {plays.map((play) => (
          <article
            key={play.id}
            className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 flex flex-col hover:border-primary-300 transition-colors"
          >
            <span className={`w-12 h-12 flex items-center justify-center rounded-lg text-2xl ${play.accent}`}>
              <i className={play.icon}></i>
            </span>
            <h3 className="mt-5 font-heading text-xl text-foreground-950">{play.title}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{play.desc}</p>
            <span className="mt-4 inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-xs text-foreground-700">
              <i className="ri-time-line"></i>
              {play.tag}
            </span>
          </article>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <Link
          to="/activities"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-foreground-900 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          <i className="ri-play-circle-line"></i>
          进入互动玩法页
        </Link>
      </div>

      <div className="mt-14 pt-10 border-t border-background-300/60">
        <h3 className="font-heading text-xl md:text-2xl text-foreground-950">按主题逛话题</h3>
        <p className="mt-2 text-sm text-foreground-600">六个常驻栏目，覆盖现场、综艺、音乐与应援。</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/topics?category=${encodeURIComponent(cat.name)}`}
              className="group flex items-center gap-3 px-4 py-4 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-300 transition-colors"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 text-xl">
                <i className={cat.icon}></i>
              </span>
              <span className="min-w-0">
                <span className="block text-sm text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </span>
                <span className="block text-xs text-foreground-500 truncate">{cat.desc}</span>
              </span>
              <i className="ri-arrow-right-s-line ml-auto text-foreground-400"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}